/* @generated */

// src/assets/ui-icon/line/redo.tsx
import * as React from "react";
var RedoLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m17.176 6.35-1.07 1.05 1.077 1.1H8.47c-1.359.005-2.512.34-3.32 1.148C4.332 10.463 4 11.628 4 13c0 1.372.333 2.537 1.148 3.352S7.128 17.5 8.5 17.5H13V16H8.632v-.001L8.5 16c-1.151 0-1.862-.28-2.291-.71-.43-.428-.709-1.139-.709-2.29 0-1.152.28-1.862.709-2.291.43-.43 1.14-.709 2.291-.709l.132.001V10h8.528l-1.053 1.067 1.067 1.054 2.84-2.877-2.838-2.894Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  RedoLine
};
